import { render, staticRenderFns } from "./btn-check.vue?vue&type=template&id=76db234b&"
import script from "./btn-check.vue?vue&type=script&lang=js&"
export * from "./btn-check.vue?vue&type=script&lang=js&"
import style0 from "./btn-check.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports